<p-fieldset class="pb-2">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-2 px-2">
      <span class="font-bold">&nbsp;{{variant().label}}&nbsp;<i class="pi pi-question-circle" [pTooltip]="variant().help"></i></span>
    </div>
  </ng-template>

  <div class="grid grid-nogutter">
    <!-- div class="flex flex-wrap p-1 items-center gap-3" -->
    @for (pd of category().descriptors; track pd; let count = $count) {
      <div class="col-span-12" [class]="count > 10 ? 'md:col-span-6':''">
        <project-descriptor [descriptorCategory]="category()" [variant]="variant()" [projectDescriptor]="pd" [profileGroup]="profileGroup()" />
      </div>
    }
  </div>
</p-fieldset>  
<!--The current issue is that editors need a little different settings than the beta readers when it comes to setting the value on the object.
Can we simplify that? Should we? Would it be faster if we split it? Probably not since they would be identical. Instead, dataService
should look at the current role or use and set the value accordingly. TODO-->
